import { render, staticRenderFns } from "./txtGroup.vue?vue&type=template&id=25c82236&scoped=true&"
import script from "./txtGroup.vue?vue&type=script&lang=js&"
export * from "./txtGroup.vue?vue&type=script&lang=js&"
import style0 from "./txtGroup.vue?vue&type=style&index=0&id=25c82236&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c82236",
  null
  
)

export default component.exports